import { SnackbarContent, styled } from '@mui/material'

import { hubloTheme, customCommonColors } from '@front/theme'

export type Variant = 'error' | 'warning' | 'success' | 'info'
type ColorSet = {
  color: string
  bgColor: string
}

const COLORS: Record<Variant, ColorSet> = {
  error: {
    color: customCommonColors.red15,
    bgColor: customCommonColors.red0,
  },
  warning: {
    color: customCommonColors.yellow15,
    bgColor: customCommonColors.yellow0,
  },
  success: {
    color: customCommonColors.green15,
    bgColor: customCommonColors.green0,
  },
  info: {
    color: customCommonColors.blue15,
    bgColor: customCommonColors.blue0,
  },
}

export const StyledSnackbarContent = styled(SnackbarContent)<{ type: Variant }>`
  &.MuiSnackbarContent-root {
    padding: 0;
    min-height: 48px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    box-shadow:
      0 4px 8px rgba(19, 20, 21, 0.08),
      0 8px 8px 2px rgba(19, 20, 21, 0.04);
    border: 1px solid ${({ type }) => COLORS[type].color};
    background-color: ${({ type }) => COLORS[type].bgColor};
  }

  .MuiSnackbarContent-message {
    width: 100%;
    height: 100%;
    padding: ${hubloTheme.spacing(1)} 13px ${hubloTheme.spacing(1)}
      ${hubloTheme.spacing(2)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${customCommonColors.black};

    & > .MuiTypography-root {
      padding: 0 ${hubloTheme.spacing(2)};
      flex: 1;
    }

    > .MuiSvgIcon-root {
      color: ${({ type }) => COLORS[type].color};
    }
  }
`
